module.exports = __webpack_public_path__ + "img/account_holder.aa7f4d5a.svg";